import * as swcHelpers from '@swc/helpers';
import { getMaxSelectableQuantity } from '../../utils/get-max-selectable-quantity.js';
import { isNoRxCLPrescription } from '../../utils/is-no-rx-cl-prescription.js';
import { SINGLE_PURCHASE } from '../../../../../types/purchase-types.js';

const getInitialState = ({ sortedAttributesSet , lensesPerBox , maxOrderableQuantity , configuratorTypeOverride  })=>{
    const defaultPurchaseType = SINGLE_PURCHASE;
    /**
   * The available quantity and allowBackOrder prop on the master variant does not need to be
   * checked here, because CL are always shown as orderable on first render
   *
   * Once a CL is fetched, the allowBackOrder status and available quantity will be updated.
   */ const maxSelectableQuantity = getMaxSelectableQuantity({
        allowBackOrder: true,
        maxOrderableQuantity
    });
    /**
   * Set the default value for each dropdown attribute.
   * If there is only 1 option in the list, set the value to that option
   * Otherwise, set the value to null
   */ const rxAttributeDefaults = sortedAttributesSet.reduce((acc, { name , attributeOptions  })=>{
        if (Object.keys(attributeOptions).length === 1) {
            return swcHelpers.objectSpread({}, acc, {
                [name]: Object.values(attributeOptions)[0]
            });
        }
        return swcHelpers.objectSpread({}, acc, {
            [name]: null
        });
    }, {});
    const allAttributesAreFilledIn = !Object.values(rxAttributeDefaults).some((defaultValue)=>defaultValue === null
    );
    const isNoRxLens = isNoRxCLPrescription({
        allAttributesAreFilledIn,
        rxAttributeDefaults
    });
    const configuratorType = isNoRxLens ? 'one-column' : 'two-column';
    const columnConfigurationsDefaults = {
        prescription: rxAttributeDefaults,
        quantity: 1
    };
    const columnUIDefaults = {
        isValid: allAttributesAreFilledIn,
        isEnabled: true,
        quantitySelector: {
            maxSelectableQuantity,
            selectionInvalidatedCount: undefined
        }
    };
    return {
        configurations: {
            purchaseType: defaultPurchaseType,
            configuratorType: configuratorTypeOverride || configuratorType,
            lensesPerBox,
            left: columnConfigurationsDefaults,
            right: columnConfigurationsDefaults,
            both: columnConfigurationsDefaults,
            subscriptionPurchaseConfigurations: {
                deliveryInterval: null
            }
        },
        queries: {
            left: {
                sku: undefined
            },
            right: {
                sku: undefined
            },
            both: {
                sku: undefined
            }
        },
        configurator: {
            hideRxConfigurator: isNoRxLens,
            invalidSubmissionsCount: undefined,
            isConfiguratorValid: allAttributesAreFilledIn,
            left: columnUIDefaults,
            right: columnUIDefaults,
            both: columnUIDefaults,
            columns: {
                areValid: allAttributesAreFilledIn,
                showError: false
            },
            columnCheckboxes: {
                areValid: columnUIDefaults.isEnabled,
                showError: false
            },
            deliveryInterval: {
                isValid: undefined,
                showError: false
            }
        }
    };
};

export { getInitialState };
//# sourceMappingURL=get-initial-state.js.map
